(() => {
  $('.product-images-nav-next').on('click', () => {
    let selectedLi = $('.product-images-entry-selected');
    let nextLi = selectedLi.next();
    if (!nextLi.length) {
      nextLi = selectedLi.siblings().first();
    }
    nextLi.addClass('product-images-entry-selected');
    selectedLi.removeClass('product-images-entry-selected');
  })
  $('.product-images-nav-prev').on('click', () => {
    let selectedLi = $('.product-images-entry-selected');
    let prevLi = selectedLi.prev();
    if (!prevLi.length) {
      prevLi = selectedLi.siblings().last();
    }
    prevLi.addClass('product-images-entry-selected');
    selectedLi.removeClass('product-images-entry-selected');
  })
  $('.product-images-zoom-close, #container-images-zoom').on('click', function (event) {
    $('.product-images-entry-selected').removeClass('product-images-entry-selected');
    $('#zoom-container').css('display', 'none');
  })
})();